module.exports = __webpack_public_path__ + "static/media/antipasto.962510b8.svg";